import { render } from "./Jogos.vue?vue&type=template&id=e64cd500&scoped=true"
import script from "./Jogos.vue?vue&type=script&lang=js"
export * from "./Jogos.vue?vue&type=script&lang=js"

import "./Jogos.vue?vue&type=style&index=0&id=e64cd500&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64cd500"]])

export default __exports__